module.exports = __webpack_public_path__ + "img/bug.14540979.svg";